import 'css-chunksrc/client/common/elementCreationForm/elementTypeSelect/styles.scss';export default {
  "elementTypeSelect": "_elementTypeSelect_1drct_1",
  "input": "_input_1drct_6",
  "icon": "_icon_1drct_22",
  "toggleArrow": "_toggleArrow_1drct_30",
  "listRoot": "_listRoot_1drct_36",
  "list": "_list_1drct_36",
  "item": "_item_1drct_48",
  "name": "_name_1drct_61",
  "opened": "_opened_1drct_68"
};